<template>
  <div class="container">
    <div
      class="our-blog our-blog-1 section-padding-top sections product-items-container row"
    >
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <div class="guardianship">
              <h5>q1：“网络游戏未成年人家长监护机制工程”是什么？</h5>
              <p>
                “网络游戏未成年人家长监护工程”是一项由杭州极峰网络科技有限公司根据国家有关规定而发起的一个项目，由中华人民共和国文化部指导，旨在加强家长对未成年人参与网络游戏的监护，引导未成年人健康、绿色参与网络游戏，和谐家庭关系的社会性公益行动。
              </p>
              <p>
                它提供了一种切实可行的方法，一种家长实施监控的管道，使家长纠正部分未成年子女沉迷游戏的行为成为可能。
              </p>
              <p>
                该项社会公益行动充分反映了中国网络游戏行业高度的社会责任感，对未成年玩家合法权益的关注以及对用实际行动营造和谐社会的愿望。
              </p>

              <h5>q2：什么情况下需要申请该项服务呢？</h5>
              <p>
                在监护人发现被监护人有沉溺《圣妖传》游戏的情况下，监护人可向极峰游戏申请发起未成年人家长监护机制。
              </p>
              <h5>
                q3：申请该项服务时需要提交哪些资料呢？如何提交呢？
              </h5>
              <p>
                申请人需通过邮寄方式向我司提交《未成年人用户家长监控服务申请书》及其中所提及需提供的附件，包含：
              </p>
              <p>
                附件1：申请人的身份证或户口本（复印件）<br />
                附件2：被申请人的身份证或户口本（复印件）<br />
                附件3：申请人与被申请人的监护法律关系证明（原件）<br />
                您在填写《未成年人用户家长监控服务申请书
                <a class="download" href="未成年人用户家长监护服务申请书.rar">下载</a>
                》时，请提供尽可能详尽、真实的玩家资料，以便帐号归属的判定。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    //这里存放数据
    return {};
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  //方法集合
  methods: {},
};
</script>
<style lang="less" scoped>
@import url("../../index.less");
@import url("./index.less");
</style>
